import {
  getBrazillianDateFormat,
  getAmericanDateFormat,
} from 'packages/common/utils/format';
import { getPeriodValidation } from './checkPeriodService';

export const checkPeriodMixin = ({ selectedDate = '', initialCheck = true }) => ({
  data() {
    return {
      isValidPeriod: true,
      infoSelectedDate: '',
      boxInformationPeriodInfo: {
        theme: 'info',
        title: 'Há períodos fechados nessa competência',
        message: '',
      },
    };
  },
  computed: {
    formatedDate() {
      return getBrazillianDateFormat(this.infoSelectedDate);
    },
  },
  watch: {
    infoSelectedDate() {
      this.boxInformationPeriodInfo = {
        theme: 'info',
        title: 'Há períodos fechados nessa competência',
        message: `Lançamentos para o dia ${this.formatedDate} estão bloqueados e não poderão ser realizados`,
      };
    },
  },
  created() {
    if (initialCheck) {
      this.checkPeriodValidation(selectedDate);
    }
  },
  methods: {
    async checkPeriodValidation(date) {
      this.infoSelectedDate = date;

      const period = getAmericanDateFormat(date);
      if (!date) return;
      this.isValidPeriod = await getPeriodValidation(period);
    },
  },
});
